import React, {useState, useEffect} from 'react';
import {useMsal} from '@azure/msal-react';
import {Navbar, Nav, Dropdown, Container} from 'react-bootstrap';
import {PersonCircle, BoxArrowRight, Person} from 'react-bootstrap-icons';
import apiClient from '../services/apiClient';
import './TopBar.scss';

const TopBar: React.FC = () => {
  const {accounts, instance} = useMsal();
  const [showDropdown, setShowDropdown] = useState(false);
  const [avatarPhoto, setAvatarPhoto] = useState<string | null>(null);
  const account = accounts[0];

  useEffect(() => {
    const fetchAvatarPhoto = async () => {
      // Check if photo is already in localStorage
      const cachedPhoto = localStorage.getItem('userAvatarPhoto');
      if (cachedPhoto) {
        setAvatarPhoto(cachedPhoto);
        return;
      }

      try {
        // Make API request to get user details
        const response = await apiClient.get(
          'https://fa-persona-backend-test2.azurewebsites.net/api/getDetails'
        );

        if (response.data && response.data.photo) {
          const photoBase64 = response.data.photo;
          // Save to localStorage
          localStorage.setItem('userAvatarPhoto', photoBase64);
          setAvatarPhoto(photoBase64);
        }
      } catch (error) {
        console.error('Failed to fetch user avatar photo:', error);
      }
    };

    if (account) {
      fetchAvatarPhoto();
    }
  }, [account]);

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: '/',
    });
  };

  const getInitials = (name?: string) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .map((word) => word.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };
  const CustomToggle = React.forwardRef<HTMLDivElement, any>(
    ({onClick}, ref) => (
      <div
        ref={ref}
        className='user-avatar-container'
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
        style={{cursor: 'pointer'}}>
        <div
          className='user-avatar'
          style={{
            backgroundImage: avatarPhoto
              ? `url(data:image/jpeg;base64,${avatarPhoto})`
              : 'none',
            backgroundSize: 'cover',
            backgroundColor: '#2d1946',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}>
          {!avatarPhoto && getInitials(account?.name)}
        </div>
        <span className='user-name d-none d-md-inline ms-2'>
          {account?.name || account?.username}
        </span>
      </div>
    )
  );

  return (
    <Navbar bg='white' className='top-bar shadow-sm border-bottom'>
      <Container fluid>
        <Nav className='ms-auto'>
          <Dropdown align='end'>
            <Dropdown.Toggle as={CustomToggle} />{' '}
            <Dropdown.Menu className='user-dropdown-menu'>
              {' '}
              <div className='user-info-header p-3 border-bottom'>
                <div className='d-flex align-items-center mb-3'>
                  <div
                    className='user-avatar-large me-3'
                    style={{
                      backgroundImage: avatarPhoto
                        ? `url(data:image/jpeg;base64,${avatarPhoto})`
                        : 'none',
                      backgroundColor: '#2d1946',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                    }}>
                    {!avatarPhoto && getInitials(account?.name)}
                  </div>
                  <div className='user-details'>
                    <div className='user-display-name fw-bold'>
                      {account?.name}
                    </div>
                    <div className='user-email text-muted small'>
                      {account?.username}
                    </div>
                  </div>
                </div>
              </div>
              <Dropdown.Item
                onClick={handleLogout}
                className='d-flex align-items-center py-2 text-danger'>
                <BoxArrowRight className='me-2' size={16} />
                Sign Out
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default TopBar;
